export const getLeafValue = (obj: object, key: string): string => {
    const [first, ...rest] = key.split(".");

    if (rest.length === 0) {
        if (obj === undefined) {
            return "no default value";
        }
        if (obj[first as keyof typeof obj] === undefined) {
            return "no default value";
        }
        const result = obj[first as keyof typeof obj];
        if (typeof result !== "string") {
            return "no default value";
        }
        return result;
    }

    return getLeafValue(obj[first as keyof typeof obj], rest.join("."));
};

export const getDefaultValueFromTerm = (translationKeys: object, term: string) => {
    return getLeafValue(translationKeys, term);
};
